<template>
  <main class="home-page" role="main">

    <div class="container pt-4 product-options">
      <div id="home-page-carousel" class="carousel desktop slide w-100" data-ride="carousel">
        <div class="carousel-inner">
                    <div class="carousel-item active">
            <router-link to="/recharge">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/data-bundle-1-new.jpg"
                alt="Data Bundle 1"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/recharge">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/data-bundle-2-new.jpg"
                alt="Data Bundle 2"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/recharge">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/data-bundle-3-new.jpg"
                alt="Data Bundle 3"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/fixed-lte/signup">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/fixed_lte_home_banner.png"
                alt="Fixed LTE"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/build-your-deal">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/build-your-deal.jpg"
                alt="Build Your Deal"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/hot-deals">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/freedom_deal_banner.png"
                alt="Freedom Deals"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/hot-deals">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/deal_image_1.jpg"
                alt="Deal 1"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/hot-deals">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/deal_image_2.jpg"
                alt="Deal 2"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/hot-deals">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/deal_image_3.jpg"
                alt="Deal 3"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/hot-deals">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/deal_image_5.jpg"
                alt="Deal 5"
              />
            </router-link>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#home-page-carousel"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#home-page-carousel"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>

    <!--Mobile -->
   <div class="container  product-options">
      <div id="home-page-carousel" class="carousel mobile slide " data-ride="carousel">
        <div class="carousel-inner">
            <div class="carousel-item active">
            <router-link to="/recharge">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/data-bundle-1-new.jpg"
                alt="Data Bundle 1"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/recharge">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/data-bundle-2-new.jpg"
                alt="Data Bundle 2"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/recharge">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/data-bundle-3-new.jpg"
                alt="Data Bundle 3"
              />
            </router-link>
          </div>
            <div class="carousel-item">
            <router-link to="/fixed-lte/signup">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/home-fixedlte-mobile.jpg"
                alt="Fixed LTE"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/build-your-deal">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/build-your-deal.jpg"
                alt="Build Your Deal"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/hot-deals">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/freedom_deal_banner.png"
                alt="Freedom Deals"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/hot-deals">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/deal_image_1.jpg"
                alt="Deal 1"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/hot-deals">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/deal_image_2.jpg"
                alt="Deal 2"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/hot-deals">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/deal_image_3.jpg"
                alt="Deal 3"
              />
            </router-link>
          </div>
          <div class="carousel-item">
            <router-link to="/hot-deals">
              <img
                class="d-block w-100"
                src="/assets/images/banners/home/deal_image_5.jpg"
                alt="Deal 5"
              />
            </router-link>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#home-page-carousel"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#home-page-carousel"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div> 
    <div class="container pt-4 product-options">
      <div class="call-to-actions card-deck">
        <div class="action-item card mobile-container">
          <div class="card-body"></div>
          <div class="card-footer text-muted">
            <div class="btn-group" role="group" aria-label="Mobile Options">
              <router-link
                class="btn btn-sm btn-outline-light"
                :to="{ name: 'hot-deals', params: { builder: false }}"
              >
                <span class="align-middle">Hot deals</span>
              </router-link>
              <router-link
                :to="{ name: 'build-your-deal', params: { builder: true }}"
                class="btn btn-sm btn-outline-light"
              >
                <span class="align-middle">Build your deal</span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="action-item card fixed-lte-container">
          <div class="card-body"></div>
          <div class="card-footer text-muted">
            <div class="btn-group" role="group" aria-label="Mobile Options">
              <router-link
                :to="{ name: 'fixed-lte-signup', params: { builder: true }}"
                class="btn btn-sm btn-outline-light"
              >
                <span class="align-middle">Explore LTE</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container pt-4 pb-5">
      <router-link class="recharge row no-gutters" to="/recharge">
        <div class="recharge-label col col-auto">
          <h1>Recharge</h1>
        </div>
        <div class="col col-auto arrow-right"></div>
        <div
          class="col col-auto recharge-instructions"
        >Recharge your bundles from here or dial *140# to recharge!</div>
      </router-link>
    </div>
  </main>
</template>

<script src="vue-google-maps.js"></script>

<script>
import _ from "lodash";
import { gmapApi } from "vue2-google-maps";

export default {
  name: "home",
  components: {},
  data() {
    return {
      addressInput: ""
    };
  },
  methods: {
    //Set current place, method used in autocomplete input.
    setPlace(place) {
      var self = this;
      var route_info = {
        name: "fixed-lte-signup",
        params: {
          place: place
        }
      };
      self.$router.push(route_info);
    }
  }
};
</script>